export interface IProjectTransactionBuyerInfo {
  remark: string;
}
